<template>
    <div>
        <div class="b_head_banner">
            <div
                v-full-background-image-path:assets="'head_circles_decor.svg'"
                class="banner_image"
            />
            <div class="banner_wrapper flex">
                <div class="banner_wrapper_inner">
                    <div class="container">
                        <div class="banner_title second_font text_center">
                            {{ content.title }}
                        </div>

                        <div class="search_form">
                            <div class="form_wrapper">
                                <div class="form_row">
                                    <input
                                        v-model="search"
                                        type="text"
                                        class="form_control"
                                        placeholder="חפש נציגים או בעלי תפקידים"
                                    />

                                    <button class="btn_serarch btn_reset" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="b_about_us">
            <leadership-group
                v-if="leadership"
                :group="leadership"
                :search="search"
                @contact-us="onContactUs"
            />

            <div class="category_wrapper">
                <div
                    v-for="(group, index) of orderedGroups"
                    :key="group.name + index"
                    class="category_row"
                >
                    <single-decorated-group
                        :group="group"
                        :search="search"
                        @contact-us="onContactUs"
                    />

                    <single-group
                        v-for="(subGroup, subIndex) of group.subGroups"
                        :key="subGroup.name + subIndex"
                        :group="subGroup"
                        :search="search"
                        @contact-us="onContactUs"
                    />
                </div>
            </div>
        </div>

        <contact-us :email="email" />
    </div>
</template>

<script>
import { mapActions } from 'vuex';
import { StatusCodes } from 'http-status-codes';
import headMixin from '@/mixins/head.mixin.js';
import SingleGroup from '@/components/about/SingleGroup';
import LeadershipGroup from '@/components/about/LeadershipGroup';
import SingleDecoratedGroup from '@/components/about/SingleDecoratedGroup';
import ContactUs from '@/components/modals/ContactUs';

export default {
    components: {
        SingleGroup,
        LeadershipGroup,
        SingleDecoratedGroup,
        ContactUs
    },

    mixins: [headMixin],

    async asyncData({ store: { dispatch }, error }) {
        try {
            const { content, meta } = await dispatch(
                'contents/show',
                'aboutPage'
            );

            const groups = await dispatch('aboutUs/index', {});

            const [leadership] = groups.splice(0, 1);

            return { groups, leadership, content, meta };
        } catch (err) {
            if (
                err.response &&
                err.response.status !== StatusCodes.INTERNAL_SERVER_ERROR
            ) {
                return error({ statusCode: err.response.status });
            }

            console.error(err);

            return error({ statusCode: StatusCodes.INTERNAL_SERVER_ERROR });
        }
    },

    data() {
        return {
            q: '',
            search: '',
            groups: [],
            email: ''
        };
    },

    computed: {
        orderedGroups() {
            const orderedGroups = [];

            for (const group of this.groups) {
                if (group.isDecorated) {
                    orderedGroups.push({ ...group, subGroups: [] });

                    continue;
                }

                if (orderedGroups.length) {
                    orderedGroups[orderedGroups.length - 1].subGroups.push(
                        group
                    );
                }
            }

            return orderedGroups;
        }
    },

    methods: {
        ...mapActions({
            getGroup: 'aboutUs/show',
            getGroups: 'aboutUs/index'
        }),

        onContactUs(email) {
            this.email = email;
            this.$openModal('contactUs');
        }
    }
};
</script>
